import { centsToEuros } from '@/constants'
import { useTranslation } from 'react-i18next'

type WalletBalanceProps = {
	balanceCents: number
	taxPercentage: number
	currencyFormatter: Intl.NumberFormat
	className?: string
	mode?: 'inline' | 'hover-swap'
}

export function WalletBalance(
	{ balanceCents, taxPercentage, currencyFormatter, className, mode = 'inline' }: WalletBalanceProps,
) {
	const { t } = useTranslation('common')

	const grossLabel = currencyFormatter.format(centsToEuros(balanceCents))

	if (taxPercentage <= 0 || balanceCents <= 0) {
		return <span className={className}>{grossLabel}</span>
	}

	const netCents = Math.round(balanceCents / (1 + taxPercentage / 100))
	const netLabel = currencyFormatter.format(centsToEuros(netCents))

	if (mode === 'hover-swap') {
		return (
			<span className={`${className ?? ''} group inline-flex flex-col items-end leading-tight`}>
				<span className="text-[9px] uppercase tracking-wider text-grey-500 font-medium">
					<span className="group-hover:hidden">{t('billing.payment.gross')}</span>
					<span className="hidden group-hover:inline">{t('billing.payment.net')}</span>
				</span>
				<span>
					<span className="group-hover:hidden">{grossLabel}</span>
					<span className="hidden group-hover:inline">{netLabel}</span>
				</span>
			</span>
		)
	}

	return (
		<>
			<span className={className}>{grossLabel}</span>
			<div className="text-xs text-grey-500 tabular-nums font-normal">
				{netLabel} {t('billing.payment.net')}
			</div>
		</>
	)
}
